import React from 'react';
import styled from 'styled-components';
import { Typography } from 'antd';
import { ProjectStage, STAGE_NAMES, STAGE_DESCRIPTIONS } from '../../constants/stages';
import StageTools from './StageTools';
import { Project } from '../../types/project';

const ToolsContainer = styled.div`
  height: 100%;
  box-sizing: border-box;
  padding: 32px;
  display: flex;
  flex-direction: column;
  max-width: 1400px;
  margin: 0 auto;
`;

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const { Title } = Typography;

const StageTitle = styled(Title)`
  margin: 0 !important;
  color: #1f2937;
`;

const DescriptionCard = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  padding: 24px;
`;

const StageDescriptionText = styled(Typography.Text)`
  color: #666;
  font-size: 15px;
  line-height: 1.8;
`;

const Footer = styled.div`
  text-align: center;
  color: #999;
  font-size: 12px;
  padding: 24px 0;
  margin-top: 24px;
`;

interface ToolsViewProps {
  selectedStage: ProjectStage;
  currentProject: Project | null;
  onEditProject: () => void;
  hideDescription?: boolean;
  title?: string;
}

export const ToolsView: React.FC<ToolsViewProps> = ({
  selectedStage,
  currentProject,
  onEditProject,
  hideDescription = false,
  title
}) => {
  return (
    <ToolsContainer>
      <ContentContainer>
        {!hideDescription && (
          <>
            <StageTitle level={3}>
              {title || STAGE_NAMES[selectedStage]}
            </StageTitle>
            
            <DescriptionCard>
              <StageDescriptionText>
                {STAGE_DESCRIPTIONS[selectedStage]}
              </StageDescriptionText>
            </DescriptionCard>
          </>
        )}

        <StageTools stage={selectedStage} />
      </ContentContainer>
      <Footer>
        © {new Date().getFullYear()} 来创业（LetStartUp）. All rights reserved.
      </Footer>
    </ToolsContainer>
  );
}; 